<div class="pending-seller-changes">
  @if (errorMessage) {
    <div class="panel error-panel">{{ errorMessage }}</div>
  }

  @if (rejectionDialogOpen) {
    <div class="panel reject-panel">
      <div class="panel-title">Reject change</div>
      <label class="field">
        <span>Rejection reason</span>
        <input class="inp" [(ngModel)]="rejectionReason" />
      </label>
      <div class="form-actions">
        <button type="button" class="act-ghost" (click)="cancelReject()">Cancel</button>
        <ng-container *staffCan="'Marketplace.SellerChanges.Moderate'"><button type="button" class="act" [disabled]="readOnly || !rejectionReason.trim()" (click)="confirmReject()">Confirm</button></ng-container>
      </div>
    </div>
  }

  @if (isLoading) {
    <div class="loading">Loading pending business changes…</div>
  } @else {
    <div class="tbl-wrap">
      <table class="tbl">
        <thead>
          <tr>
            @if (!businessId) {
              <th>Business</th>
            }
            <th>Summary</th>
            <th>Submitted by</th>
            <th>Submitted at</th>
            <th>Status</th>
            <th class="actions">Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (change of changes; track change.id) {
            <tr>
              @if (!businessId) {
                <td>{{ change.businessName || change.businessId }}</td>
              }
              <td class="summary-cell">{{ change.changeSummary }}</td>
              <td>
                @if (change.submittedBy && userNames.has(change.submittedBy)) {
                  <a class="user-link" [routerLink]="['/profile', change.submittedBy]">{{ userNames.get(change.submittedBy) }}</a>
                } @else {
                  {{ change.submittedBy || '—' }}
                }
              </td>
              <td>{{ change.submittedAt | date: 'short' }}</td>
              <td>
                <span class="pill" [class.pill-amber]="change.status === 'Pending'">{{ change.status }}</span>
              </td>
              <td class="actions">
                <button type="button" class="act-link" (click)="toggleDetails(change)">
                  {{ expandedChangeId === change.id ? 'Hide' : 'View' }}
                </button>
                @if (change.status === 'Pending') {
                  <ng-container *staffCan="'Marketplace.SellerChanges.Moderate'"><button type="button" class="act-link" style="margin-left:10px" [disabled]="readOnly" (click)="approve(change)">Approve</button></ng-container>
                  <ng-container *staffCan="'Marketplace.SellerChanges.Moderate'"><button type="button" class="act-link danger" style="margin-left:10px" [disabled]="readOnly" (click)="reject(change)">Reject</button></ng-container>
                }
              </td>
            </tr>
            @if (expandedChangeId === change.id) {
              <tr class="detail-row">
                <td [attr.colspan]="businessId ? 5 : 6">
                  @if (getDiffs(change).length) {
                    <table class="diff-tbl">
                      <thead>
                        <tr>
                          <th class="diff-field">Field</th>
                          <th>Before</th>
                          <th>After</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (diff of getDiffs(change); track diff.field) {
                          <tr>
                            <td class="diff-field">{{ diff.field }}</td>
                            <td class="diff-before">{{ diff.before ?? '—' }}</td>
                            <td class="diff-after">{{ diff.after ?? '—' }}</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  } @else {
                    <div class="muted">No field-level diff was captured for this change — summary: {{ change.changeSummary }}</div>
                  }
                </td>
              </tr>
            }
          }
          @if (!changes.length) {
            <tr><td [attr.colspan]="businessId ? 5 : 6" class="empty">No pending business changes.</td></tr>
          }
        </tbody>
      </table>
    </div>

    @if (totalPages > 1) {
      <div class="pagination">
        <button
          type="button"
          class="act-ghost act-sm"
          [disabled]="page === 1"
          (click)="setPage(page - 1)">
          ← Prev
        </button>
        <span class="page-info">Page {{ page }} of {{ totalPages }}</span>
        <button
          type="button"
          class="act-ghost act-sm"
          [disabled]="page === totalPages"
          (click)="setPage(page + 1)">
          Next →
        </button>
      </div>
    }
  }
</div>
